import { request, requestList, rawRequest, buildQuery, orgBase } from '@/api/http'
import type {
  Summary,
  Metrics,
  MigrationSummary,
  MoneyTrend,
  MoneyPoint,
  SystemRisk,
  HndlUrgency,
  ExpiringCerts,
  TrendPoint,
  ImpactHeadline,
  FrameworkPosture,
  CrosswalkRollup,
  HeatmapCell,
} from '@/api/types'

export const analyticsApi = {
  summary(orgId: string): Promise<Summary> {
    return request(`${orgBase(orgId)}/summary`)
  },
  metrics(orgId: string): Promise<Metrics> {
    return request(`${orgBase(orgId)}/metrics`)
  },
  migration(orgId: string): Promise<MigrationSummary> {
    return request(`${orgBase(orgId)}/migration`)
  },
  systems(orgId: string): Promise<SystemRisk[]> {
    return requestList(`${orgBase(orgId)}/systems`)
  },
  hndl(orgId: string): Promise<HndlUrgency> {
    return request(`${orgBase(orgId)}/hndl`)
  },
  expiringCerts(orgId: string): Promise<ExpiringCerts> {
    return request(`${orgBase(orgId)}/expiring-certs`)
  },
  trends(orgId: string): Promise<TrendPoint[]> {
    return requestList(`${orgBase(orgId)}/trends`)
  },
  inventoryTrends(orgId: string, invId: string): Promise<TrendPoint[]> {
    return requestList(`${orgBase(orgId)}/inventories/${invId}/trends`)
  },
  moneyTrend(orgId: string, days = 30): Promise<MoneyTrend> {
    return request(`${orgBase(orgId)}/money-trend${buildQuery({ days })}`)
  },
  moneyTrends(orgId: string): Promise<MoneyPoint[]> {
    return requestList(`${orgBase(orgId)}/money-trends`)
  },
  inventoryMoneyTrends(orgId: string, invId: string): Promise<MoneyPoint[]> {
    return requestList(`${orgBase(orgId)}/inventories/${invId}/money-trends`)
  },
  impact(orgId: string): Promise<ImpactHeadline> {
    return request(`${orgBase(orgId)}/impact`)
  },
  crosswalk(orgId: string): Promise<FrameworkPosture[]> {
    return requestList(`${orgBase(orgId)}/crosswalk`)
  },
  crosswalkHeatmap(orgId: string): Promise<HeatmapCell[]> {
    return requestList(`${orgBase(orgId)}/crosswalk${buildQuery({ level: 'asset' })}`)
  },
  crosswalkRollup(orgId: string): Promise<CrosswalkRollup> {
    return request(`${orgBase(orgId)}/crosswalk/rollup`)
  },
  // Executive report returns templated HTML/markdown text (not the JSON envelope).
  async executiveReport(orgId: string): Promise<string> {
    const resp = await rawRequest(`${orgBase(orgId)}/report/executive`)
    return resp.text()
  },
}
